import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton'
import MainLayout from '../Layouts/MainLayout'
import ImageDetail from './ImageDetail'

function ImageDetailContainer() {
  const [navParams, setNavParams] = useState({
      navTitle: "Image Details",
      navSubTitle: "Welcome to ImagesBazaar"
  })

  const handleNavParams = (obj)=>{
    setNavParams({
        ...navParams,
        ...obj
    })
  }

  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
        <ImageDetail handleNavParams={handleNavParams}/>
    </MainLayout>
  )
}

export default ImageDetailContainer